import { LocalizedText } from './localized-text';
import type { EventLabel } from '@/client/hooks/use-event-labels';

/**
 * Primary title line for portfolio / trade / history / notification rows.
 * Shows the parent event name when the market belongs to an event group
 * (e.g. "World Cup Winner"), otherwise the bare market name. Localized via the
 * stored per-locale maps resolved by useEventLabels.
 */
export function EventPrimaryTitle({
  label,
  marketName,
  className,
}: {
  label?: EventLabel;
  marketName: string;
  className?: string;
}) {
  const hasEvent = !!label?.eventTitle;
  return (
    <span className={className}>
      <LocalizedText i18n={hasEvent ? label?.eventTitleI18n : label?.marketNameI18n}>
        {hasEvent ? (label!.eventTitle as string) : marketName}
      </LocalizedText>
    </span>
  );
}

/**
 * Outcome (sub-market / team) name — e.g. "England". Rendered only when the row
 * belongs to a MULTI-market event group (World Cup Winner -> team per market).
 * For a standalone market, or an event that wraps a single market, the name is
 * already the primary title, so this returns null to avoid repeating it.
 */
export function EventOutcomeName({
  label,
  marketName,
  className,
}: {
  label?: EventLabel;
  marketName: string;
  className?: string;
}) {
  if (!label?.eventTitle || !label?.multiMarket) return null;
  return (
    <span className={className}>
      <LocalizedText i18n={label.marketNameI18n}>{marketName}</LocalizedText>
    </span>
  );
}
